import { takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import {
  addNewPhysicalInventorySaga,
  editPhysicalInventorySaga,
  deletePhysicalInventorySaga,
} from "./saga";

export default function* watchPhysicalInventory() {
  yield takeLatest(actionTypes.ADD_NEW_PHYSICAL_INVENTORY, addNewPhysicalInventorySaga);
  yield takeLatest(actionTypes.EDIT_PHYSICAL_INVENTORY, editPhysicalInventorySaga);
  yield takeLatest(actionTypes.DELETE_PHYSICAL_INVENTORY, deletePhysicalInventorySaga);
}